module.exports = __webpack_public_path__ + "img/chile.8282f78.webp";